import { render } from "./QueueCompact.vue?vue&type=template&id=fec53640&scoped=true"
import script from "./QueueCompact.vue?vue&type=script&lang=js"
export * from "./QueueCompact.vue?vue&type=script&lang=js"

import "./QueueCompact.vue?vue&type=style&index=0&id=fec53640&scoped=true&lang=scss"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec53640"]])

export default __exports__